import { render, staticRenderFns } from "./EmailComponent.vue?vue&type=template&id=27ecc132&scoped=true&"
import script from "./EmailComponent.vue?vue&type=script&lang=js&"
export * from "./EmailComponent.vue?vue&type=script&lang=js&"
import style0 from "./EmailComponent.vue?vue&type=style&index=0&id=27ecc132&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ecc132",
  null
  
)

export default component.exports